module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedBold.dc5638e.woff";